export const IDENTITY_REQUIRED_EVENT = "blackspace:identity-required";

export type IdentityIntent = {
  action: string;
  returnTo?: string;
};

export function hasIdentity() {
  return Boolean(localStorage.getItem("token"));
}

export function requireIdentity(action: string, returnTo?: string) {
  if (hasIdentity()) return true;
  window.dispatchEvent(new CustomEvent<IdentityIntent>(IDENTITY_REQUIRED_EVENT, {
    detail: {
      action,
      returnTo: returnTo || `${window.location.pathname}${window.location.search}${window.location.hash}`,
    },
  }));
  return false;
}
